(function(angular){
	'use strict';

	angular.module('losAngelesHomePriceChartModule', [
		'highChartsModule'
	]);
})(window.angular);